export const types = {
  LOGIN_SUCCESS: "login-success",
  LOGOUT_SUCCESS: "logout-success",
};
